import React from "react";
import Buscador from "../../Home/SeccionBuscador/Buscador";
//import Filtros from './Filtros'

const SeccionIzquierda = (props) => {
  const handleCombosBusquedaChange = (propiedad, valor) => {
    props.onSelectChange(propiedad, valor);
  };

  const handleCombosOrigenBusquedaChange = (valor) => {
    props.onSelectOrigenChange(valor);
  };

  const handleCombosDestinoBusquedaChange = (valor) => {
    props.onSelectDestinoChange(valor);
  };

  const handleComboPeriodoBusquedaChange = (fecha, destino, codigoProvinciaOrigen, idPuntoDeEmbarque) => {
    props.onSelectPeriodoChange(fecha, destino, codigoProvinciaOrigen, idPuntoDeEmbarque);
  };

  const handleComboEmbarqueBusquedaChange = (valor) => {
    props.onSelectEmbarqueBusquedaChange(valor);
  };

  const handleAdultosChange = (fecha) => {
    props.onAdultosChange(fecha);
  };

  const handleMenoresChange = (fecha) => {
    props.onMenoresChange(fecha);
  };

  const handleEdadChange = (clave, valor) => {
    props.onEdadChange(clave, valor);
  };

  // Definición de estilos, se puede mantener aquí o pasar como prop si es dinámico
  const estilos = {
    estilo1: "",
    estilosInputs: "",
    estilosInputFecha: "",
    estiloBoton: "",
    estilosHabitaciones: "",
    estiloEdadMenor: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12",
    estiloInputEdadMenor: "col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
  };

  return (
    <aside className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
      <div className="filtros">
        <Buscador
          busqueda={props.busqueda}
          estilos={estilos}
          onSelectChange={handleCombosBusquedaChange}
          onSelectOrigenChange={handleCombosOrigenBusquedaChange}
          onSelectDestinoChange={handleCombosDestinoBusquedaChange}
          onSelectPeriodoChange={handleComboPeriodoBusquedaChange}
          onSelectEmbarqueBusquedaChange={handleComboEmbarqueBusquedaChange}
          onAdultosChange={handleAdultosChange}
          onMenoresChange={handleMenoresChange}
          onEdadChange={handleEdadChange}
          solosYsolas={props.solosYsolas}
        />
      </div>
      {/*<Filtros />*/}
    </aside>
  );
};

export default SeccionIzquierda;



// WEBPACK FOOTER //
// ./src/components/Resultados/SeccionIzquierda/index.js